import { GQL } from '../graphQl'

export const GetAllWorkflowByVersionByIdQuery = () => GQL`query GetAllWorkflowByVersionByIdQuery($id: uuid!) {
  workflow_versions_by_pk(id: $id) {
    id
    template_id
    version_no
    created_on
    created_by
    workflow_stages {
      created_by
      created_on
      department_id
      end_step
      start_step
      duration
      duration_type
      qc_parent_step_id
      resource_group
      on_start_validation {
        id
        name
        type
        validation_groups(order_by: {sequence: asc}) {
          id
          operator_to_next_group
          sequence
          type
          validation_conditions {
            bool_value
            created_on
            date_value
            id
            int_list
            int_value
            left_operand
            operator
            string_list
            string_value
          }
        }
      }
      workflow_step_resources_associations{
        core_material_master{
          id
          resource_type_value{
            name
          }         
        }
      }
      outsourced
      quality_check
      end_coordinates
      id
      name
      type
      start_coordinates
      sequence
      phase_id
      sequence
      escalation_threshold
      qc_form_template_id
         core_form_template{
        name
      }
      trigger_actions {
      trigger_action
      trigger_timing
      target_field
      target_value_int 
        mandatory
        form_template_id
        core_form_template{
        name
        }
        trigger_action
        metadata
      }
           core_user_group {
        name
      }
    }
    workflow_transitions {
      created_by
      created_on
      id
      line_vertices
      name
      next_step
      prev_step
      template_version_id
    }
    workflow_template {
      name
      id
      feature_id
      category
    }
  }
}
`
export const getAlternateMaterialWorkflowQuery = () => GQL`query GetAlternateMaterialWorkflow {
  workflow_stages(where: {workflow_version: {active: {_eq: true}, workflow_template: {system_generated: {_eq: true}, name: {_eq: "DEFAULT ALTERNATE MATERIAL WORKFLOW"}}}, type: {_eq: 2}}) {
    id
    name
    duration
    duration_type
  }
}`

export const getDashboardDataQuery = () => GQL`query GetDashboardDataQuery($conditions: user_steps_view_bool_exp, $materialConditions: user_steps_view_bool_exp, $formConditions: user_steps_view_bool_exp, $documentConditions: user_steps_view_bool_exp, $tenantConditions: user_steps_view_bool_exp, $bomConditions: user_steps_view_bool_exp, $upcomingConditions: user_steps_view_bool_exp, $orderBy: [user_steps_view_order_by!], $distinctOn: [user_steps_view_select_column!]) {
  material_workflows: user_steps_view_aggregate(where: $materialConditions, distinct_on: $distinctOn) {
    aggregate {
      count(columns: workflow_instance_id)
    }
  }
  form_workflows: user_steps_view_aggregate(where: $formConditions, distinct_on: $distinctOn) {
    aggregate {
      count(columns: workflow_instance_id)
    }
  }
  tenant_workflows: user_steps_view_aggregate(where: $tenantConditions, distinct_on: $distinctOn) {
    aggregate {
      count(columns: workflow_instance_id)
    }
  }
  document_workflows: user_steps_view_aggregate(where: $documentConditions, distinct_on: $distinctOn) {
    aggregate {
      count(columns: workflow_instance_id)
    }
  }
  bom_workflows: user_steps_view_aggregate(where: $bomConditions, distinct_on: $distinctOn) {
    aggregate {
      count(columns: workflow_instance_id)
    }
  }
  user_steps_view(where: $conditions, order_by: $orderBy, distinct_on: $distinctOn) {
    due_date
    planned_start_date
    workflow_type
    category
    step_name
    template_version_id
    workflow_instance_id
    workflow_name
    approval_tenant_id
    material_id
    form_id
    core_form{
      id
      project_id
      due_date
      template_version{
        core_form_template{
          id
          name
        }
      }
    }
  }
  upcoming: user_steps_view(where: $upcomingConditions, order_by: $orderBy, distinct_on: $distinctOn) {
    due_date
    planned_start_date
    workflow_type
    step_name
    category
    template_version_id
    workflow_instance_id
    workflow_name
    approval_tenant_id
    material_id
    form_id
    core_form{
      id
      due_date
      template_version{
        core_form_template{
          id
          name
        }
      }
    }
  }
}`

export const CreateWorkflowTemplateWIthPhasesMutation = () => GQL`mutation CreateWorkflowTemplateWIthPhasesMutation($data: workflow_templates_insert_input!) {
  insert_workflow_templates_one(object: $data) {
    id
    workflow_versions {
      id
      workflow_stages {
        id
        name
        end_coordinates
        start_coordinates
      }
    }
  }
} `
export const GetWorkflowTypesQuery = () => GQL`query GetWorkflowTypesQuery {
  custom_list_values(where: {custom_list: {system_generated: {_eq: true}, name: {_eq: "WORKFLOW_TYPES"}}}) {
    id
    name
  }
}`
export const CreateWorkflowStepsMutation = () => GQL`mutation CreateWorkflowStepsMutation($data: [workflow_stages_insert_input!]!) {
  insert_workflow_stages(objects: $data) {
    returning {
      id
      sequence
      start_coordinates
      end_coordinates
      name
    }
  }
}`
export const CreateWorkflowTransitionMutation = () => GQL`mutation CreateWorkflowTransitionMutation($data: [workflow_transitions_insert_input!]!) {
  insert_workflow_transitions(objects: $data) {
    returning {
      id
    }
  }
}`
export const getWorkFLowTemplatesQuery = () => GQL`query getWorkFLowTemplatesQuery($limit: Int, $offset: Int, $searchKeyword: String, $orderBy: [workflow_templates_order_by!]  ) {
  workflow_templates(
    where: {tenant_id: {_is_null: false} name: {_ilike: $searchKeyword}}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    created_by
    created_on
    feature_id
    id
    name
    tenant_id
    type
    type_value {
      name
    }
    system_generated
    created_by_user {
      email
      first_name
      id
      last_name
    }
    type_value {
      id
      name
    }
      core_form_template {
      value:id
      label:name
      form_type
    }
  }
  workflow_templates_aggregate(where: {tenant_id: {_is_null: false} name: {_ilike: $searchKeyword}}) {
    aggregate {
      count
    }
  }
}
`
export const getfullWorkFLowTemplatesQuery = () => GQL`query getfullWorkFLowTemplatesQuery($conditions: workflow_templates_bool_exp) {
  workflow_templates(
    where:$conditions
    order_by: {created_on: desc}
  ) {
    created_by
    created_on
    feature_id
    id
    name
    tenant_id
    type
    category
    type_value {
      name
    }
    system_generated
    created_by_user {
      email
      first_name
      id
      last_name
    }
    type_value {
      id
      name
    }
      core_form_template {
      id
      name
      form_type
    }
  }
}
`
export const GetWorkFlowDataByTemplateIdQuery = () => GQL`query GetWorkFlowDataByTemplateIdQuery($id: uuid!) {
  workflow_templates_by_pk(id: $id) {
    workflow_versions(order_by: {created_on: asc}) {
      active
      id
      template_id
      version_no
      draft
      created_by
      created_on
      created_by_user {
        email
        first_name
        id
        last_name
      }
    }
    name
    id
    objective
  }
}
`
export const updateWorkFlowTemplateMutaion = () => GQL`mutation UpdateWorkflowTemplate($draft: Boolean!, $templateId: uuid!, $updates: workflow_update_input!) {
  update_workflow_template(draft: $draft, template_id: $templateId, updates: $updates) {
    message
  }
}

`
export const InsertValidationMutation = () => GQL`mutation InsertValidation($object: validations_insert_input!) {
  insert_validations_one(object: $object) {
    id
  }
}`
export const UpdateWorkflowTemplateNameMutation = () => GQL`mutation UpdateWorkflowTemplateNameMutation($id: uuid!,  $payload: workflow_templates_set_input!) {
  update_workflow_templates_by_pk(
    pk_columns: {id: $id}
    _set: $payload
  ) {
    id
  }
}`
export const workflowDataBasedOnInstanceIdQuery = () => GQL`query workflowDataBasedOnInstanceIdQuery($id: uuid!) {
  workflow_instances_by_pk(id: $id) {
    id
    state_value {
      id
      name
    }
    core_comments(order_by:{created_on:desc}, limit:1){
    comment
    }
    transition_history(where: {end_date: {_is_null: true}}) {
      id
      qc_form {
      id
        status
      }
      prev_step {
        id
        name
      }
      initiated_by
    }
    workflow_version {
      id
      workflow_template {
        id
        name
        type_value {
          name
        }
      }
    }
    workflow_instance_steps(where: {workflow_step: {workflow_stage_instances: {id: {_eq: $id}}}}) {
      step_id
      planned_start_date
      planned_end_date
      instance_step_resources{
        workflow_step_id
        resource_id
        factory_resource_instance {
            id
            name
            resource_id
        }
      }
      instance_step_assignees {
        user_id
        assigned_user {
          id
          first_name
          last_name
          email
        }

      }
      core_attachments {
        file_name
        file_size
        blob_key
        created_by_user {
          first_name
          last_name
        }
      }
    }
    workflow_stage {
      id
      name
      end_step
      duration
      duration_type
      quality_check
      qc_parent_step_id
      qc_form_template_id
      outsourced
      workflow_step_resources_associations {
        resource_id
      }
      current_step_transition_history(where: {instance_id: {_eq: $id}}      order_by: {end_date: asc_nulls_first}) {
        id
        start_date
        end_date
        form_id
          qc_form {
          id
          status
        }
      }
      trigger_actions {
        trigger_timing
        mandatory
        core_form_template {
          id
          name
        }
      }
      core_user_group {
        name
        core_user_group_members(where: {deleted: {_eq: false}}) {
          user_id
          deleted
        }
      }
      next_transition {
        id
        name
        next_workflow_stage{
          id
        }
      }
    }
  }
}`
export const getTransitionDataQuery = () => GQL`query getTransitionDataQuery($transitionId: uuid) {
  transition_history(where: {instance_id: {_eq: $transitionId}}, order_by: {start_date: asc}) {
    action_taken
    completed_by
    end_date
    step_id
    id
    prev_step_id
    start_date
  }
  workflow_instance_steps(where: {workflow_instance_id: {_eq: $transitionId}}) {
    step_id
    planned_start_date
    planned_end_date
    projected_start_date
    projected_end_date
  }
}`
export const getNextStepWithTransitionIdQuery = () => GQL`query getNextStepWithTransitionIdQuery($id: uuid!) {
  workflow_transitions_by_pk(id: $id) {
    name
    next_workflow_stage {
      id
      name
      duration
      end_step
        trigger_actions {
        trigger_timing
        mandatory
        form_template_id
       }
      core_user_group {
      name
        core_user_group_members {
          user_id
        }
      }
    }
  }
}`

export const CheckIfUserGroupIsAttachedToWorkflowQuery = () => GQL`query CheckIfUserGroupIsAttachedToWorkflow($id: uuid!) {
  workflow_stages(where: {department_id: {_eq: $id}}) {
    workflow_version {
      workflow_template {
        id
        name
      }
    }
  }
}`

export const getAllStepDocsExceptGivenStepQuery = () => GQL`query getAllStepDocsExceptGivenStepQuery($instanceId: uuid!, $currentStepId: uuid) {
  workflow_instance_steps(
    where: {workflow_instance_id: {_eq: $instanceId}, core_attachments: {id: {_is_null: false}}, step_id: {_neq: $currentStepId}}
  ) {
    core_attachments {
      blob_key
      file_type
      file_size
      workflow_step_id
      file_name
      id
      workflow_instance_step {
        workflow_step {
          name
          id
        }
      }
    }
  }
}`

export const startMaterialWorkflowMutation = () => GQL`mutation startMaterialWf($workflowData: [material_workflow_data_input!]!, $formId: uuid!) {
  start_material_workflow(materials_workflow_data: $workflowData, form_id: $formId) {
    message
  }
}`

export const GetJobOrderMaterialLinksQuery = () => GQL`query GetJobOrderMaterialLinksQuery($formId: uuid!) {
  job_order_material_links(where: {form_id: {_eq: $formId}}) {
    bar_code_blob_key
    core_form {
      forms_material_lists {
        core_material {
        material_name
        id
        }
        status
      }
    }
    workflow_instance {
      id
      state_value {
        name
      }
      template_version_id
      transition_history(order_by: {end_date: desc}, limit: 1) {
        end_date
        current_workflow_step {
          id
          name
          core_user_group {
            name
          }
        }
      }
      current_instance_step {
        projected_end_date
        instance_step_resources {
          resource_id
          factory_resource_instance {
            name
            id
            resource_id
          }
        }
        instance_step_assignees{
        user_id
        }
        workflow_step {
          name
          end_step
          core_user_group {
          name
          id
          core_user_group_members{
            user_id
          }
          }
        }
      }
      core_material_master {
        material_name
        id
        material_product_code {
          product_code
        }
      }
    }
  }
}

 `
export const getformsDataByWFstepIdAndInstanceIdQuery = () => GQL`query getformsDataByWFstepIdAndInstanceIdQuery($stepId: uuid, $instanceId: uuid) {
  transition_history(where: {step_id: {_eq: $stepId}, instance_id: {_eq: $instanceId}} order_by: {qc_form: {created_on: desc}}) {
    form_id
      current_workflow_step{
      name
    }
    qc_form {
      status
      created_on
      updated_on
        template_version{
        template_id
      }
      forms_user_lists {
      field_id
        core_user {
          first_name
          last_name
        }
      }
      forms_metadata_by_id {
        point_value
        bool_value
        date_value
        field_id
        field_type_id
        int_value
        point_value
        product_code_value
        project_id
        string_value
        time_value
      }
        forms_table {
        field_id
        table_data
      }
    }
  }
}`

export const getLastStepHistoryDataQuery = () => GQL`query getLastStepHistoryDataQuery($id:uuid!){
  workflow_instances_by_pk(id: $id) {
    id
    transition_history(limit: 1, order_by: {end_date: desc}) {
      step_id
        current_workflow_step{
        id
        qc_parent_step_id
        qc_form_template_id
      }
      qc_form {
        closed_by
        updated_by
        status
      }
      end_date
      start_date
      id
    }
  }
}`
export const getStartigStepsForInviteTenantWfQuery = () => GQL`query getStartigStepsForInviteTenantWfQuery($templateName: String = "DEFAULT TENANT APPROVAL WORKFLOW", $featureId: Int, $tenantId: uuid ) {
  workflow_templates(
    where: {name: {_eq: $templateName}, feature_id: {_eq: $featureId}, system_generated: {_eq: true}, tenant_id: {_eq: $tenantId}}
  ) {
    name
    id
    tenant_id
    type_value {
      name
    }
    workflow_versions(where: {active: {_eq: true}}) {
          id
          active
      workflow_stages(where: {start_step: {_eq: true}}) {
        name
        id
        duration_type
        duration
      }
    }
  }
}
`
export const getMaterialResource = () => GQL`query getMaterialResource {
  core_material_master(where: {type: { _eq: 2}}, order_by: {created_on: desc}) {
     type
     material_name
    id
    resource_type_value{
      id
      name
    }
  }
}`
export const getCorefeatureAndCategoryApiQuery = () => GQL`{
  core_features {
    id
    name
    allowed_workflow_categories
    allowed_trigger_actions
  }
  workflow_categories{
    id
    name
  }
}`
export const getworkflowInstanceBasicDataQuery = () => GQL`query getworkflowInstanceBasicDataQuery($id: uuid!) {
  workflow_instances_by_pk(id: $id) {
    id
    created_on
    state_value {
      id
      name
    }
    workflow_version {
      id
      workflow_template {
        id
        name
        type_value {
          name
        }
      }
    }
  workflow_stage {
      id
      name
      end_step
      duration
      duration_type
    }
  }
}`
